import { Locale } from '@/i18n/locales';
import { NavBarProps } from '@/ui/layout/NavBar/NavBar';
import { LogoProps } from '@/ui/Logo';
import { useTranslations } from 'next-intl';
import { getLocale, getTranslations } from 'next-intl/server';

export const logoProps: LogoProps = { href: '/' };

export type GetLinksOpts = {
  home?: boolean;
  kitchensink?: boolean;
};

function prepareLinks(
  t: ReturnType<typeof useTranslations<'layout.navbar.links'>>,
  opts?: GetLinksOpts
) {
  return [
    ...(opts?.home ? [{ href: '/', exact: true, text: t('home') }] : []),
    { href: '/experience', text: t('experience') },
    { href: '/projects', text: t('portfolio') },
    { href: '/about-me', text: t('about-me') },
    ...(opts?.kitchensink ? [{ href: '/kitchensink', text: t('kitchensink') }] : []),
  ] as const;
}

export async function getLinks(
  locale?: Locale,
  opts: { home?: boolean; kitchensink?: boolean } = {}
) {
  if (!locale) {
    locale = (await getLocale()) as Locale;
  }
  const t = await getTranslations({ namespace: 'layout.navbar.links', locale });
  return prepareLinks(t, opts);
}

export function useLinks(opts?: GetLinksOpts) {
  const t = useTranslations('layout.navbar.links');
  return prepareLinks(t, opts);
}

export const pathOverrides: { path: string; exact?: boolean; overrides: Partial<NavBarProps> }[] = [
  {
    path: '/',
    exact: true,
    overrides: { topStyle: 'transparentInverted', slotProps: { container: { maxWidth: 'xl' } } },
  },
];
